import { ChangeDetectorRef, EventEmitter, Output } from "@angular/core";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormArray, FormBuilder, FormControl } from "@angular/forms";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { BehaviorSubject } from "rxjs";
import { T } from "_node_modules/@angular/cdk/keycodes";
import { ControlUser } from "../model/controlUser";
import { DevicePilomat } from "../model/devicePilomat";
import { DevicePilomatIO } from "../model/devicePilomatIO";
import { DeviceService } from "../service/device.service";
import { Log } from "../util/log";
import { isNumeric } from 'rxjs/internal-compatibility/index';

@Component({
  selector: "app-device-ios-editor",
  templateUrl: "./device-ios-editor.component.html",
  styleUrls: ["./device-ios-editor.component.css"],
})
export class DeviceIosEditorComponent implements OnInit {

  @ViewChild("ioloader", { static: true }) loader;

  iosData: DevicePilomatIO[] = [];

  iosForm: FormGroup;
  items: FormArray = new FormArray([]);

  numbersList: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  typeList: any[] = DevicePilomatIO.TYPES_NEW;
  modeList: string[] = DevicePilomatIO.MODES;

  serial: string;
  version: number;


  numberError: boolean = false;
  typeError: boolean = false;
  tooManyError: boolean = false;
  notNumberError: boolean = false;
  negativeNumberError: boolean = false;
  inpOtherOnBusError: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DeviceIosEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private deviceService: DeviceService,
    private cdRef: ChangeDetectorRef,
    private formBuilder: FormBuilder
  ) {
    this.serial = data.serial;
    this.version = data.version;

    // creo una copia per non modificare l'originale
    for (let ios of data.iosData) {
      this.iosData.push(Object.create(ios));
    }

    for (let ios of this.iosData) {
      this.items.push(this.createItem(ios));
    }

    this.iosForm = this.formBuilder.group({
      items: this.items
    });

    for (let control of this.items.controls) {
      Log.debug("items.control: " + JSON.stringify(control.value));
    }
  }

  ngOnInit(): void { }

  ngAfterViewInit() {

    setTimeout(() => {
      if (this.version < 100) {
        this.typeList = DevicePilomatIO.TYPES;
      }
    });

  }

  closeDialog() {
    this.dialogRef.close();
  }

  createItem(io: DevicePilomatIO): FormGroup {

    Log.debug("\n\n createItem ");
    Log.debug(io);

    return new FormGroup({
      number: new FormControl(io.number),
      typeString: new FormControl(io.typeListObject),
      mode: new FormControl(io.mode),
      name: new FormControl(io.name),
    });
  }

  addEmptyItem(): void {

    Log.debug("clicked addEmptyItem ");

    this.items.controls.push(new FormGroup({
      number: new FormControl(0),
      typeString: new FormControl(this.typeList[0]),
      mode: new FormControl(this.modeList[0]),
      name: new FormControl(''),
    }));
  }

  deleteItem(i: number): void {
    Log.debug("clicked deleteItem ");

    this.items.controls.splice(i, 1);

  }

  saveIOs() {
    Log.debug("clicked saveIOs ");

    this.numberError = false;
    this.typeError = false;
    this.tooManyError = false;
    this.negativeNumberError = false;
    this.notNumberError = false;
    this.inpOtherOnBusError = false;

    this.iosData = [];

    for (let i = 0; i < this.items.controls.length; i++) {

      let io = new DevicePilomatIO();
      if (this.items.controls[i].value.number >= 0 && this.items.controls[i].value.number <= 80) {
        io.number = Number(this.items.controls[i].value.number);
      } else {
        this.notNumberError = true;
        break;
      }

      Log.debug(this.items.controls[i].value);


      if (isNumeric(this.items.controls[i].value.number)) {
        io.number = Number(this.items.controls[i].value.number);
      } else {
        this.notNumberError = true;
        break;
      }

      io.number = Number(this.items.controls[i].value.number);

      io.type = this.items.controls[i].value.typeString.value;
      io.typeString = this.items.controls[i].value.typeString.text

      io.mode = this.items.controls[i].value.mode;
      io.name = this.items.controls[i].value.name;
      io.serial = this.serial;
      this.iosData.push(io);
    }

    // check for duplicate in type and numbers
    for (let i = 0; i < this.iosData.length; i++) {
      if (this.iosData[i].type == "inp-other" && this.iosData[i].mode == "BUS") {
        this.inpOtherOnBusError = true;
      }

      for (let j = 0; j < this.iosData.length; j++) {

        if (Number(this.iosData[i].number) > 80) {
          this.tooManyError = true;
          break;
        }

        if (Number(this.iosData[i].number) < 0) {
          this.negativeNumberError = true;
          break;
        }


        if (i == j) {
          continue;
        }

        if (Number(this.iosData[i].number) == Number(this.iosData[j].number)) {
          this.numberError = true;
          break;
        }
        if (this.iosData[i].type == this.iosData[j].type) {
          if (this.iosData[i].type != "inp-other") {
            this.typeError = true;
            break;
          }
        }
      }

      if (this.numberError || this.typeError) {
        break;
      }
    }

    if (this.numberError || this.typeError) {
      Log.debug("Errore dati duplicati");
    } else if (this.tooManyError) {
      Log.debug("Errore numero troppo elevato");
    } else if (this.notNumberError) {
      Log.debug("Errore inserimento valore non numerico");
    } else if (this.negativeNumberError) {
      Log.debug("Errore numero negativo assegnato ad un I/O");
    } else if (this.inpOtherOnBusError) {
      Log.debug("Errore Input other configurato su BUS");
    } else {
      Log.debug("IOs: \n\n\n");
      Log.debug(this.iosData);
      this.dialogRef.close({ iosData: this.iosData });
    }
  }

}
